export enum PaymentType {
    oneTime = "8333faf7-d5e5-4f6a-80fe-4e7177b7fa0e",
    recurring = "a74d53a4-80e8-41b5-8069-193027c70c40",
}
